import BaseService from "./BaseService";

const URL_BASE = `${process.env.REACT_APP_ENDPOINT}usuarios/api/v1/usuarios/`;
const URL_BASE_OBTER_TOKEN = `${process.env.REACT_APP_ENDPOINT}usuarios/api/v1/usuarios/tokenFinanceiro`;

class UsuarioService extends BaseService {
  async BuscarDadosUsuarioPorId(idUsuario: number) {
    const retorno = await this.get(URL_BASE + idUsuario);
    return retorno;
  }

  async obterTokenAcessoFinanceiro(requestToken: string) {
    const retorno = await this.post(URL_BASE_OBTER_TOKEN, requestToken);
    return retorno;
  }

  async obtemRoleUsuario(requestToken: string) {
    const retorno = await this.get(URL_BASE + `${requestToken}/roles`);
    return retorno;
  }

  async tokenCentralAjuda(idUsuario: number, liberadoSuporte = false) {
    const query = liberadoSuporte ? "?tags=suporte_liberado" : "";

    const url = `${URL_BASE}${idUsuario}/tokenCentralAjuda${query}`;

    const retorno = await this.get(url);
    return retorno;
  }
}

const usuarioService = new UsuarioService();

export default usuarioService;
